var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPeriwinkle2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 79,
    viewBox: "0 0 81 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 81,
    height: 79,
    fill: "#1E1E1E"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1153_2894)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -1431,
    y: -1,
    width: 1512,
    height: 982,
    rx: 10,
    fill: "url(#paint0_linear_1153_2894)"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.997324,
    x: 31.4958,
    y: 79.7025,
    width: 127.469,
    height: 46.7279,
    rx: 23.364,
    transform: "rotate(-45.193 31.4958 79.7025)",
    fill: "#EB5757",
    stroke: "#111111",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.52371,
    d: "M12.7668 19.6845C6.25346 9.22189 19.9755 -1.96592 28.912 6.52093C34.5485 11.8738 43.5296 11.3731 48.5362 5.42685C56.474 -4.00079 71.3546 5.59239 66.0446 16.7141C62.6955 23.7289 65.947 32.1157 73.1494 35.0398C84.5685 39.6758 80.0432 56.7925 67.8249 55.1792C60.1185 54.1617 53.147 59.8457 52.5917 67.5992C51.7113 79.892 34.034 80.8776 31.7926 68.7588C30.3789 61.1151 22.8187 56.2412 15.2732 58.1091C3.30996 61.0705 -3.08995 44.5629 7.74308 38.6863C14.5758 34.9798 16.8749 26.2835 12.7668 19.6845ZM47.6963 46.0437C52.5959 42.049 53.3294 34.8387 49.3347 29.9392C45.34 25.0396 38.1297 24.3061 33.2302 28.3008C28.3306 32.2955 27.5971 39.5057 31.5918 44.4053C35.5865 49.3049 42.7967 50.0384 47.6963 46.0437Z",
    fill: "#8482E7",
    stroke: "#111111",
    strokeWidth: 3
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1153_2894",
    x1: -675,
    y1: -1,
    x2: -675,
    y2: 981,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1D4E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.474002,
    stopColor: "#EAEDFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D4E1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1153_2894"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -1431,
    y: -1,
    width: 1512,
    height: 982,
    rx: 10,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeriwinkle2);
export default __webpack_public_path__ + "static/media/Periwinkle-2.5fd661de8faf20a3523247f5dd7c2f8d.svg";
export { ForwardRef as ReactComponent };